import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('../views/index.vue')
const Win = () => import('../views/win.vue')
const Mac = () => import('../views/mac.vue')
const BugList = () => import('../views/bug/bugList.vue')
const BugDetail = () => import('../views/bug/bugDetail.vue')
const BugForm = () => import('../views/bug/bugForm.vue')
const Notice = () => import('../views/notice/noticeList.vue')
Vue.use(Router)
const routes = [
  { path: '/', redirect: '/index' },
  { path: '/index', component: Index },
  { path: '/win', component: Win },
  { path: '/mac', component: Mac },
  { path: '/bugList', component: BugList },
  { path: '/bugDetail', component: BugDetail },
  { path: '/bugForm', component: BugForm },
  { path: '/notice', component: Notice },
];
const router = new Router({
  routes
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js